module.exports = __webpack_public_path__ + "static/img/get-app-ios-es.5343017.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/buttons/get-app-ios-es.svg
// module id = k+UU
// module chunks = 0